import { useQuery } from '@tanstack/react-query';
import { getCandidateById, getVendorById } from '../Services/GetUsersDetails';

export const useVendorById = (id, enabled = true) =>
    useQuery({
        queryKey: ['vendor', id],
        queryFn: () => getVendorById(id),
        enabled: !!id && enabled, // don't run unless id is valid
        staleTime: 5 * 60 * 1000, // 5 minutes: data is "fresh"
        cacheTime: 5 * 60 * 1000, // 5 minutes: data stays in cache
    });

export const useCandidateById = (id, enabled = true) =>
    useQuery({
        queryKey: ['candidate', id],
        queryFn: () => getCandidateById(id),
        enabled: !!id && enabled,
        staleTime: 5 * 60 * 1000,
        cacheTime: 5 * 60 * 1000,
    });
